<template>
  <div>
    <v-row v-if="false">
      <v-col class="mt-2 pt-2">
        <label class="text-h6 text-weight-black">Outras Cores:</label>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col
        v-for="indexParent in productSelected.parents"
        :key="`item_${indexParent}`"
        cols="12"
        xs="4"
        sm="4"
        md="3"
        lg="3"
        class="mt-0 pt-0 card-product"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-img
              @click="showAnotherProduct(products[indexParent])"
              :lazy-src="products[indexParent].image[0]"
              max-height="180"
              max-width="180"
              class="ma-2"
              :src="products[indexParent].image[0]"
              v-bind="attrs"
              v-on="on"
            ></v-img>
          </template>
          <span>{{ products[indexParent].color }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    productSelected: {},
    products: [],
    showAnotherProduct: {
      type: Function,
    },
  },
};
</script>
